import { Fragment, type FC } from 'react';

import { OperationTypesEnum } from '../constants/shared.js';
import type { ApprovalSequenceType } from '../types/shared.js';
import LogicalGroup from './LogicalGroup.jsx';
import Separator from './Separator.jsx';

type Props = {
  items: ApprovalSequenceType;
  approvalProcessId: string;
  reminderSendingAllowed: boolean;
};

const ApprovalSequence: FC<Props> = ({
  items,
  approvalProcessId,
  reminderSendingAllowed,
}) => {
  return (
    <div className="grid w-full gap-4">
      {items.map((logicalGroup, index) => {
        return (
          <Fragment key={JSON.stringify(logicalGroup)}>
            {index === 0 ? null : (
              <Separator variant={OperationTypesEnum.enum.then} />
            )}
            <LogicalGroup
              rows={logicalGroup}
              approvalProcessId={approvalProcessId}
              reminderSendingAllowed={reminderSendingAllowed}
            />
          </Fragment>
        );
      })}
    </div>
  );
};

export default ApprovalSequence;
